import React from "react";
import LessonStatusResult from "../LessonStatusResult/LessonStatusResult";
import { GroupsDropdown } from "../GroupsDropdown/GroupsDropdown";
import { StatusDropdown } from "../StatusDropdown/StatusDropdown";
import { DatePick } from "../../DatePicker/DatePicker";
import { ReactComponent as PlusIcon } from "../../../assets/icons/Plus.svg";
import LessonTeachersDropdown from "../LessonTeachersDropdown/LessonTeachersDropdown";
import { ReactComponent as HalfCircleICon } from "../../../assets/icons/filter/half-circle-svgrepo-com.svg";
import { CategoryDropdown } from "./CategoryDropdown";

const NotificationPageHead = ({ showAddBtn, filter, openModal, count }) => {
  return (
    <div className="lesson-page-header-container">
      <div className="lesson-table-page-header-container">
        <div className="lesson-page-filter-container">
          <div className="lesson-table-header-content">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              <div className="lesson-table-datepick">
                <DatePick deviceType="desktop" />
              </div>

              <CategoryDropdown />
              <div className="lesson-table-right-container">
                <div className="lesson-page-apply-btn">
                  <div className="lesson-table-btn-container lesson-page ">
                    <button className="add-detail" onClick={() => filter()}>
                      Tətbiq et
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationPageHead;
